<script setup lang="ts">
import { ref } from 'vue'
import DetailsForm from '@/views/manage-account/create/details.vue'
import PersonalDetailsLetterhead from '@/components/dashboard/shared/PersonalDetailsLetterhead.vue'
import { usePersonalDetailsDisplay } from '@/composables/usePersonalDetailsDisplay'

withDefaults(
  defineProps<{
    context?: 'account' | 'matching'
  }>(),
  {
    context: 'account',
  }
)

const editInfo = ref(false)
const { details } = usePersonalDetailsDisplay()

const toggleEdit = () => {
  editInfo.value = !editInfo.value
}

const closeEdit = () => {
  editInfo.value = false
}
</script>

<template>
  <div
    class="sa-personal-details-block"
    :class="`sa-personal-details-block--${context}`"
  >
    <p v-if="context === 'account'" class="sa-personal-details-block__lead">
      {{ $t('Dashboard.Account.Personal.Lead') }}
    </p>

    <template v-if="editInfo">
      <DetailsForm @cancel-edit="closeEdit" @saved="closeEdit" />
    </template>

    <PersonalDetailsLetterhead
      v-else-if="details"
      show-edit
      :name-label="
        context === 'matching'
          ? $t('Dashboard.Status.Personal.FullName')
          : $t('Dashboard.Account.Personal.FullName')
      "
      :address-label="
        context === 'matching'
          ? $t('Dashboard.Status.Personal.HomeAddress')
          : $t('Dashboard.Account.Personal.Address')
      "
      :edit-label="
        context === 'matching'
          ? $t('Dashboard.Status.Personal.Edit')
          : $t('Dashboard.Account.Personal.Edit')
      "
      :name-test-id="context === 'account' ? 'full-name' : undefined"
      :address-test-id="context === 'account' ? 'address' : undefined"
      :edit-test-id="context === 'account' ? 'edit-personal' : undefined"
      @edit="toggleEdit"
    />
  </div>
</template>
